// In style.js
import styled from "styled-components";
import { Button } from "antd";

export const StyledButton = styled(Button)`
  background-color: rgb(24, 144, 255);
  border-color: rgb(24, 144, 255);
  color: white;

  &:hover {
    background-color: rgb(20, 122, 216); /* Slightly darker blue */
    border-color: rgb(20, 122, 216);
  }
`;

export const CenteredContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 10px;
`;

export const TargetCard = styled.div`
  background-color: rgb(255, 255, 255);
  padding: 10px 20px;
  text-align: center;
  font-size: 14px;
  font-weight: 450;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: black;
  border: 2px solid black;
  height: 33px; /* Same height as StyledButton */
  strong {
    color: black;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row; /* Align buttons in a row */
  justify-content: center;
  align-items: center;
  gap: 16px; /* Adds space between buttons */
  margin-top: 10px;
`;

export const Container = styled.div`
  margin: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const Heading = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;

  h1 {
    text-align: center;
  }

  p {
    text-align: center;
  }
`;

export const Filters = styled.div``; // Assuming Filters component has its own styling
